export default "__VITE_ASSET__pfu$7Y9O__"